import React, { useState } from 'react';

import ModalHeader from '@components/modals/ModalHeader';
import ModalContainer from '@components/modals/ModalContainer';

import MaterialRequisitionModal from '@features/material-requisition/components/MaterialRequisitionModal';
import MaterialRequestTypeModal from '@features/material-requisition/components/MaterialRequestTypeModal';
import {
	MATERIAL_REQUISITION_PURPOSE,
	MATERIAL_REQUISITION_TYPE
} from '@features/material-requisition/utils';
import { useFetchMaterialRequisitionPurposeQuery } from '@features/material-requisition/api/materialRequisitionApi';

const MaterialRequisitionModalWrapper = ({ onCloseModal }) => {
	const { data } = useFetchMaterialRequisitionPurposeQuery();
	const [showMaterialRequestTypeModal, setShowMaterialRequestTypeModal] = useState(true);
	const [selectedMaterialType, setSelectedMaterialType] = useState({
		requisitionPurpose: MATERIAL_REQUISITION_PURPOSE[0].constant,
		materialType: MATERIAL_REQUISITION_TYPE[0].constant
	});

	const toggleMaterialRequestTypeModal = () => {
		setShowMaterialRequestTypeModal(!showMaterialRequestTypeModal);
	};

	const handleMaterialTypeChange = (e) => {
		const { name, value } = e.target;
		setSelectedMaterialType((prevState) => ({
			...prevState,
			[name]: value,
			materialType: name === 'requisitionPurpose' ? MATERIAL_REQUISITION_TYPE[0].constant : value
		}));
	};

	return (
		<ModalContainer className="buyer-request-details-modal width-784-dialog">
			<div
				className={`common-popup body-scroll ${showMaterialRequestTypeModal ? 'material-request-type-modal' : 'products-upload-modal'}`}
			>
				<ModalHeader title="Enter material request details" onClose={onCloseModal} />
				{showMaterialRequestTypeModal && (
					<MaterialRequestTypeModal
						selectedMaterialType={selectedMaterialType}
						handleMaterialTypeChange={handleMaterialTypeChange}
						onCloseModal={onCloseModal}
						toggleMaterialRequestTypeModal={toggleMaterialRequestTypeModal}
						materialRequisitionPurpose={data}
					/>
				)}
				{!showMaterialRequestTypeModal && (
					<MaterialRequisitionModal
						selectedMaterialType={selectedMaterialType}
						goBack={() => setShowMaterialRequestTypeModal(true)}
						onCloseModal={onCloseModal}
					/>
				)}
			</div>
		</ModalContainer>
	);
};

export default MaterialRequisitionModalWrapper;
